import { ORDER_PREFERENCES_API } from 'constants/AppConstants';

export default async (requestBody) => {
  try {
    const response = await fetch(ORDER_PREFERENCES_API, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody),
    });
    const json = await response.json();
    if (response.status !== 200) return { ok: false, json };
    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
